import React, { useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { StyledtBlocWrapper } from 'containers/AmcDetailsPage/MyRefundsTab/styles';
import {
  StyledTabs,
  StyledTab,
} from 'containers/AmcDetailsPage/MyRefundsTab/Refunds/styles';
import Refunds from 'components/Refunds';
import { isEmpty } from 'lodash';

function a11yProps(index: number) {
  return {
    id: `my-contracts-tab-${index}`,
    'aria-controls': `my-contracts-tabpanel-${index}`,
  };
}

export interface tabItemProps {
  label: string;
}

const MyRefunds = ({
  ...props
}: {
  intl: IntlShape;
  getRefundAMCDetails: Function;
  refundDetails: any;
  refunds: any;
  beneficiaries: [];
}) => {
  const [expandeds, setExpanded] = useState<boolean | String>(false);
  const [value, setValue] = React.useState(0);
  const handleChange = (index: String, item: any) => (
    event: React.ChangeEvent<{}>,
    isExpanded: boolean,
  ) => {
    props.getRefundAMCDetails(item);
    setExpanded(isExpanded ? index : false);
  };

  const handleChangeTab = (event: React.ChangeEvent<{}>, newValue: number) => {
    // eslint-disable-next-line
    setValue(newValue);
  };

  const getTabItems = () =>
    ['TOUS'].concat(
      props.beneficiaries.map((ele: { member: string }) => ele.member),
    );

  const getListRefunds = () => {
    const tabItems = getTabItems();

    if (value === 0) return props.refunds;

    const refundsUsingFilter: { [key: string]: [] } = {};

    Object.keys(props.refunds).forEach((key) => {
      const _filtredRefundForKey = props.refunds[key].filter(
        (item: any) => tabItems[value] === item.beneficiary,
      );
      if (!isEmpty(_filtredRefundForKey))
        refundsUsingFilter[key] = _filtredRefundForKey;
    });

    return refundsUsingFilter;
  };

  return (
    <StyledtBlocWrapper height="auto">
      <StyledTabs
        value={value}
        onChange={handleChangeTab}
        aria-label="my contracts tabs"
      >
        {(getTabItems() as []).map((tab: tabItemProps, index) => (
          <StyledTab
            key={index}
            label={tab}
            {...a11yProps(index)}
            disableRipple
          />
        ))}
      </StyledTabs>
      <Refunds
        listIndex={0}
        isLoading={false}
        refunds={getListRefunds()}
        refundDetails={props.refundDetails}
        expanded={expandeds}
        handleChange={(index: String, item: any) => handleChange(index, item)}
      />
    </StyledtBlocWrapper>
  );
};
export default injectIntl(MyRefunds);
